
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38.05 44.15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M9.14 13.08h-5a.85.85 0 00-.85.85v5a.85.85 0 00.85.85h5a.85.85 0 00.84-.85v-5a.85.85 0 00-.84-.85zm-.85 5H5v-3.31h3.29zM9.14 23.24h-5a.85.85 0 00-.85.84v5a.85.85 0 00.85.85h5A.85.85 0 0010 29v-5a.85.85 0 00-.86-.76zm-.85 5H5v-3.31h3.29zM9.14 33.39h-5a.85.85 0 00-.85.85v5a.85.85 0 00.85.84h5a.85.85 0 00.86-.88v-5a.85.85 0 00-.86-.81zm-.85 5H5v-3.31h3.29zM12.43 17.25h11.69a.84.84 0 000-1.68H12.43a.84.84 0 100 1.68zM12.43 27.41h7.48a.85.85 0 000-1.69h-7.48a.85.85 0 100 1.69zM24.12 35.87H12.43a.85.85 0 100 1.69h11.69a.85.85 0 000-1.69z"}}),_c('path',{attrs:{"d":"M38.05 25.13a8 8 0 00-7.14-7.94V7a.84.84 0 00-.85-.84h-6.53v-2a.85.85 0 00-.85-.85h-3.22a4.1 4.1 0 00-8 0H8.22a.85.85 0 00-.84.85v2H.84A.84.84 0 000 7v36.3a.85.85 0 00.84.85h29.22a.85.85 0 00.85-.85V33.07a8 8 0 007.14-7.94zM9.07 4.94h3.13a.84.84 0 00.8-.84 2.41 2.41 0 014.82 0 .85.85 0 00.85.84h3.13V9H9.07zM1.69 42.46V7.81h5.69v2a.85.85 0 00.84.84h14.46a.85.85 0 00.85-.84v-2h5.69v9.38a8 8 0 000 15.88v9.39zm28.37-11a6.3 6.3 0 116.3-6.3 6.3 6.3 0 01-6.3 6.27z"}}),_c('path',{attrs:{"d":"M32.68 22.22l-4 4-1.2-1.2a.84.84 0 00-1.19 1.19L28 28.05a.85.85 0 001.2 0l4.64-4.64a.84.84 0 000-1.19.85.85 0 00-1.16 0z"}})])])
          )
        }
      }
    